<template>
  <div class="flex flex-col items-center md:items-start w-full md:w-1/2 pl-0 md:pl-20">
    <Title :title="project.title"></Title>
    <p>{{ project.description }}</p>
    <p style="margin-top: 10px">
      <strong>Technologies used: </strong> {{ project.technologiesUsed }}
    </p>
    <div class="flex flex-col md:flex-row items-center mt-10 md:mt-0 md:items-start h-full">
      <a v-if="project.link !== '#'" class="mb-2 md:mb-0 md:self-end bg-blue-500 hover:bg-blue-700 rounded text-white font-bold py-2 px-4" :href="project.link">
        <i class="fas fa-chevron-right"></i>
        Visit project
      </a>
      <a v-if="project.gitHubLink !== '#'" class="md:self-end bg-gray-500 hover:bg-gray-700 rounded text-white font-bold py-2 px-4 ml-2" :href="project.gitHubLink">
        <i class="fab fa-github"></i>
        Visit GitHub repository
      </a>
    </div>
  </div>
  <div class="flex flex-col items-center md:items-start w-full md:w-1/2 h-full pl-5 pr-0 md:pr-20 mt-10 md:mt-0">
    <vueper-slides class="w-full" fixed-height="400px">
      <vueper-slide
          style="background-size: contain; background-repeat: no-repeat;"
          v-for="(media, i) in project.medias"
          :key="i"
          :image="media.image" />
    </vueper-slides>
  </div>
</template>

<script>
import Title from "./Title";
import {VueperSlide, VueperSlides} from "vueperslides";

export default {
  name: "Project",

  components: {
    Title,
    VueperSlides,
    VueperSlide
  },

  props: {
    project: Object
  }
}
</script>

<style>
  .vueperslides__arrow {
    color: black !important;
  }

  .vueperslides__arrow svg {
    stroke-width: 2 !important;
  }
</style>